import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';

export default class BirthdayBanner extends Component {
  view() {
    const birthdays = app.forum.attribute('todayBirthdays') || [];

    if (birthdays.length === 0) return <div />;

    const names = birthdays.map((b) => b.firstName ? `${b.displayName} (${b.firstName})` : b.displayName);
    let nameStr;
    if (names.length === 1) {
      nameStr = names[0];
    } else {
      nameStr = names.slice(0, -1).join(', ') + ' ' + app.translator.trans('florcarioca-birthday.forum.banner.and') + ' ' + names[names.length - 1];
    }

    return (
      <div className="BirthdayBanner">
        <div className="container">
          <span className="BirthdayBanner-cake">🎂</span>
          {' '}
          {app.translator.trans('florcarioca-birthday.forum.banner.message', { names: nameStr })}
        </div>
      </div>
    );
  }
}
